// extracted by mini-css-extract-plugin
export var animationContainer = "_fs-0";
export var footer = "_fs-1";
export var gray = "_fs-2";
export var lineItem = "_fs-3";
export var lineItemImage = "_fs-4";
export var lineItemInfo = "_fs-5";
export var lineItemText = "_fs-6";
export var lineItems = "_fs-7";
export var modalContent = "_fs-8";
export var options = "_fs-9";
export var orderName = "_fs-a";
export var refundAmount = "_fs-b";